import ManageGroups from './ManageGroups'
import enhance from './ManageGroups.enhancer'

export default enhance(ManageGroups)

export const manageGroupColumns = [
  {
      width: 200, label: 'Group Name', field: 'groupName'
  },
    {
        width: 50, label: 'Traps', field: 'totalTraps', align: 'flex-end'
    },
  {
    width: 200, label: 'Contributors', field: 'totalViewer', align: 'flex-end'
  },
  {
    width: '100%', hidden: true, hideHeader: true
  }
]



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroups/index.js